import React from "react";
import { cn } from "@/lib/utils";
import { statusMeta } from "@/lib/constants";

export const StatusBadge = ({ status, className, withDot = true, size = "md" }) => {
  const meta = statusMeta(status);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-semibold",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs",
        meta.badge,
        className
      )}
    >
      {withDot && <span className={cn("h-1.5 w-1.5 rounded-full", meta.dot)} />}
      {meta.label}
    </span>
  );
};
